'use strict';

exports.__esModule = true;
exports.TasksView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Context from "@prisma-cms/context";
// import FavoritedIcon from "material-ui-icons/Favorite";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _filters = require('@prisma-cms/filters');

var _filters2 = _interopRequireDefault(_filters);

var _timeline = require('@prisma-cms/timeline');

var _timeline2 = _interopRequireDefault(_timeline);

var _materialUi = require('material-ui');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Table = require('apollo-cms/lib/DataView/List/Table');

var _Select = require('./Task/Status/Select');

var _Select2 = _interopRequireDefault(_Select);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _PlayArrow = require('material-ui-icons/PlayArrow');

var _PlayArrow2 = _interopRequireDefault(_PlayArrow);

var _Stop = require('material-ui-icons/Stop');

var _Stop2 = _interopRequireDefault(_Stop);

var _ThumbUp = require('material-ui-icons/ThumbUp');

var _ThumbUp2 = _interopRequireDefault(_ThumbUp);

var _Task = require('./Task');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TasksView = exports.TasksView = (_temp = _class = function (_TableView) {
  _inherits(TasksView, _TableView);

  function TasksView() {
    _classCallCheck(this, TasksView);

    return _possibleConstructorReturn(this, _TableView.apply(this, arguments));
  } // constructor(props) {
  //   super(props);
  //   this.state = {
  //     ...this.state,
  //   }
  // }


  TasksView.prototype.componentWillMount = function componentWillMount() {
    this.state.columnData = this.initColumns();
    _TableView.prototype.componentWillMount && _TableView.prototype.componentWillMount.call(this);
  };

  TasksView.prototype.getButtons = function getButtons(object) {
    var buttons = [];
    var _props = this.props,
        createTimerProcessor = _props.createTimerProcessor,
        updateTimerProcessor = _props.updateTimerProcessor,
        classes = _props.classes;
    var UserLink = this.context.UserLink;

    if (object) {
      var taskId = object.id,
          name = object.name,
          Timers = object.Timers,
          CreatedBy = object.CreatedBy;

      var _ref = CreatedBy || {},
          createdById = _ref.id;

      var currentUser = this.context.user;
      var activeTimers = Timers && Timers.filter(function (n) {
        return n.stopedAt === null;
      }) || [];

      if (activeTimers.length) {
        activeTimers.map(function (n) {
          var id = n.id,
              CreatedBy = n.CreatedBy;
          buttons.push(_react2.default.createElement(UserLink, {
            key: id,
            user: CreatedBy,
            size: 'small',
            showName: false
          }));
        });
      }

      if (currentUser) {
        var currentUserId = currentUser.id;
        var activeTimer = activeTimers.find(function (n) {
          return n.CreatedBy.id === currentUserId;
        });

        if (activeTimer) {
          var timerId = activeTimer.id;
          buttons.push(_react2.default.createElement(_materialUi.IconButton, {
            key: 'stop',
            onClick: function onClick() {
              return updateTimerProcessor({
                variables: {
                  data: {
                    stopedAt: new Date()
                  },
                  where: {
                    id: timerId
                  }
                }
              });
            },
            className: classes.button
          }, _react2.default.createElement(_Stop2.default, null)));
        } else {
          buttons.push(_react2.default.createElement(_materialUi.IconButton, {
            key: 'start',
            onClick: function onClick() {
              return createTimerProcessor({
                variables: {
                  data: {
                    Task: {
                      connect: {
                        id: taskId
                      }
                    }
                  }
                }
              });
            },
            className: classes.button
          }, _react2.default.createElement(_PlayArrow2.default, null)));
        }
      }
    }

    return buttons;
  };

  TasksView.prototype.initColumns = function initColumns() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        ProjectLink = _context.ProjectLink,
        UserLink = _context.UserLink,
        TaskLink = _context.TaskLink,
        TaskStatus = _context.TaskStatus,
        currentUser = _context.user,
        createTaskReactionProcessor = _context.query.createTaskReactionProcessor;

    var _ref2 = currentUser || {},
        currentUserId = _ref2.id;

    var _props2 = this.props,
        classes = _props2.classes,
        updateTaskProcessor = _props2.updateTaskProcessor,
        createTimerProcessor = _props2.createTimerProcessor,
        updateTimerProcessor = _props2.updateTimerProcessor,
        deleteTaskReaction = _props2.deleteTaskReaction;
    return [// {
    //   id: "Project",
    //   label: "Проект",
    //   renderer: (value, record) => {
    //     return value ? <ProjectLink
    //       object={value}
    //     /> : null;
    //   },
    // },
    // {
    //   id: "id",
    //   label: "Задача",
    //   renderer: (value, record) => {
    //     return record ? <TaskLink
    //       object={record}
    //     /> : null;
    //   },
    // },
    {
      id: "status",
      label: "Статус",
      hidden: false,
      renderer: function renderer(value, record) {
        // console.log("status", record);
        return value ? _react2.default.createElement(Grid, {
          container: true,
          spacing: 8,
          alignItems: 'center'
        }, _react2.default.createElement(Grid, {
          item: true
        }, _react2.default.createElement(TaskStatus, {
          value: value
        }))) : null;
      }
    }, {
      id: "name",
      label: "Задача",
      hidden: true,
      renderer: function renderer(value, record) {
        return record ? _react2.default.createElement(TaskLink, {
          object: record
        }) : null;
      }
    }, {
      id: "Project",
      label: "Проект",
      hidden: true,
      renderer: function renderer(value, record) {
        return value ? _react2.default.createElement(ProjectLink, {
          object: value
        }) : null;
      }
    }, {
      id: "id",
      label: "Подробности задачи",
      hidden: false,
      renderer: function renderer(value, record) {
        return record ? _react2.default.createElement(_Task.TaskView, {
          data: {
            object: record
          },
          classes: classes,
          mutate: updateTaskProcessor,
          createTimer: createTimerProcessor,
          updateTimer: updateTimerProcessor,
          showStatus: false,
          showCreatedBy: false
        }) : null;
      }
    }, {
      id: "createdAt",
      label: "Дата постановки",
      hidden: false,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "startDatePlaning",
      label: "Планируемая дата начала",
      hidden: true,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "endDatePlaning",
      label: "Планируемая дата завершения",
      hidden: true,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "startDate",
      label: "Дата начала",
      hidden: true,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "endDate",
      label: "Дата завершения",
      hidden: true,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "planes",
      label: "Плановые сроки",
      hidden: false,
      renderer: function renderer(value, record) {
        var date = value ? (0, _moment2.default)(value).format("lll") : null;
        var dates = [];
        var createdAt = record.createdAt,
            startDatePlaning = record.startDatePlaning,
            startDate = record.startDate,
            endDatePlaning = record.endDatePlaning,
            endDate = record.endDate;
        var min = (0, _moment2.default)(startDate || startDatePlaning || createdAt);
        var max = endDate || endDatePlaning ? (0, _moment2.default)(endDate || endDatePlaning) : null; // console.log("startDate", min);
        // console.log("endDate", endDate);

        if (min && max) {
          var startTime = min.toDate().getTime();
          var endTime = max.toDate().getTime();
          dates.push({
            startDate: startTime,
            endDate: endTime
          });
        }

        return dates.length ? _this2.renderTimeline(dates, {}) : null;
      }
    }, {
      id: "CreatedBy",
      label: "Постановщик",
      hidden: false,
      renderer: function renderer(value, record) {
        return value ? _react2.default.createElement(UserLink, {
          user: value,
          size: 'small'
        }) : null;
      }
    }, // {
    //   id: "RelatedTo",
    //   label: "Связано с",
    //   renderer: (value, record) => {
    //     // console.log("status", TaskLink);
    //     // return value ? <TaskStatus
    //     //   value={value}
    //     // /> : null;
    //     return value && value.length ? value.map(n => <TaskLink
    //       key={n.id}
    //       object={n}
    //     />).reduce((a, b) => [a, ", ", b]) : null;
    //   },
    // },
    {
      id: "Reactions",
      label: "Нравится",
      hidden: false,
      renderer: function renderer(value, record) {
        if (!value) {
          return null;
        }

        var taskId = record.id;
        var users = value && value.length ? value.filter(function (n) {
          return n.CreatedBy && n.CreatedBy.id !== currentUserId;
        }) : [];
        var like = void 0;
        var liked = currentUserId && value && value.find(function (n) {
          return n.CreatedBy && n.CreatedBy.id === currentUserId;
        }) || null;

        if (liked) {
          var likedId = liked.id;
          like = _react2.default.createElement(_materialUi.IconButton, {
            onClick: function onClick(event) {
              deleteTaskReaction({
                variables: {
                  where: {
                    id: likedId
                  }
                }
              });
            }
          }, _react2.default.createElement(_ThumbUp2.default, {
            color: 'primary'
          }));
        } else {
          like = _react2.default.createElement(_materialUi.IconButton, {
            onClick: function onClick(event) {
              // createTaskReactionProcessor({
              // });
              _this2.mutate({
                mutation: (0, _graphqlTag2.default)(createTaskReactionProcessor),
                variables: {
                  data: {
                    type: "UpVote",
                    Task: {
                      connect: {
                        id: taskId
                      }
                    }
                  }
                }
              });
            }
          }, _react2.default.createElement(_ThumbUp2.default, {
            color: 'action'
          }));
        }

        return _react2.default.createElement('div', {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }, _react2.default.createElement(Grid, {
          container: true,
          spacing: 8
        }, users.length ? users.map(function (n) {
          return _react2.default.createElement(Grid, {
            key: n.id,
            item: true
          }, _react2.default.createElement(UserLink, {
            user: n.CreatedBy,
            size: 'small',
            showName: false
          }));
        }) : null), like);
      }
    }];
  };

  TasksView.prototype.renderDate = function renderDate(date) {
    return date ? (0, _moment2.default)(date).format("lll") : null;
  };

  TasksView.prototype.getColumns = function getColumns() {
    var columnData = this.state.columnData;
    return columnData;
  };

  TasksView.prototype.renderFilters = function renderFilters() {
    var _props3 = this.props,
        filters = _props3.filters,
        setFilters = _props3.setFilters;
    return _react2.default.createElement(_react.Fragment, null, filters && setFilters ? _react2.default.createElement(_filters2.default, {
      queryName: 'tasks',
      filters: filters,
      setFilters: setFilters
    }) : null, this.renderTimeline());
  };

  TasksView.prototype.renderTimeline = function renderTimeline(defaultDates, options) {
    var _context2 = this.context,
        Grid = _context2.Grid,
        theme = _context2.theme; // console.log(this.context);

    var caption = theme.typography.caption;
    var _props4 = this.props,
        objectsConnection = _props4.data.objectsConnection,
        classes = _props4.classes;
    var tasks = objectsConnection ? objectsConnection.edges.map(function (n) {
      return n.node;
    }) : [];
    var minDate = 0;
    var maxDate = 0;
    var dates = [];
    tasks.map(function (n) {
      var createdAt = n.createdAt,
          startDatePlaning = n.startDatePlaning,
          startDate = n.startDate,
          endDatePlaning = n.endDatePlaning,
          endDate = n.endDate;
      var min = (0, _moment2.default)(startDate || startDatePlaning || createdAt);
      var max = endDate || endDatePlaning ? (0, _moment2.default)(endDate || endDatePlaning) : null; // console.log("startDate", min);
      // console.log("endDate", endDate);

      if (min && max) {
        var startTime = min.toDate().getTime();
        var endTime = max.toDate().getTime();
        dates.push({
          startDate: startTime,
          endDate: endTime
        });

        if (!minDate || minDate > startTime) {
          minDate = startTime;
        }

        if (!maxDate || maxDate < endTime) {
          maxDate = endTime;
        }
      }
    });
    var showDates = defaultDates ? defaultDates : dates; // console.log("dates", dates);
    // console.log("tasks", tasks);
    // console.log("minDate", minDate);
    // console.log("maxDate", maxDate);

    var timeline = void 0;

    if (minDate && maxDate && showDates && showDates.length) {
      timeline = _react2.default.createElement(Grid, {
        container: true
      }, _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement('span', {
        style: _extends({}, caption, {
          padding: 5
        })
      }, (0, _moment2.default)(minDate).format("DD.MM.YYYY"))), _react2.default.createElement(Grid, {
        item: true,
        xs: true
      }, _react2.default.createElement(_timeline2.default, _extends({
        minDate: minDate,
        maxDate: maxDate,
        dates: showDates,
        onStartDateChange: function onStartDateChange() {},
        onEndDateChange: function onEndDateChange() {}
      }, options))), _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement('span', {
        style: _extends({}, caption, {
          padding: 5
        })
      }, (0, _moment2.default)(maxDate).format("DD.MM.YYYY")))));
    }

    return timeline;
  };

  TasksView.prototype.render = function render() {
    var _context3 = this.context,
        Pagination = _context3.Pagination,
        Grid = _context3.Grid;
    var _props5 = this.props,
        page = _props5.page,
        setShowAll = _props5.setShowAll,
        showAll = _props5.showAll;
    var _props$data = this.props.data,
        objectsConnection = _props$data.objectsConnection,
        loading = _props$data.loading,
        limit = _props$data.variables.first;

    var _ref3 = objectsConnection || {},
        edges = _ref3.edges,
        aggregate = _ref3.aggregate;

    var _ref4 = aggregate || {},
        _ref4$count = _ref4.count,
        count = _ref4$count === undefined ? 0 : _ref4$count;

    var showAllButton = void 0;

    if (showAll) {
      showAllButton = _react2.default.createElement(_materialUi.Button, {
        onClick: function onClick(event) {
          return setShowAll(false);
        }
      }, "\u0421\u043A\u0440\u044B\u0442\u044C");
    } else if (limit && count && count > limit && setShowAll) {
      showAllButton = _react2.default.createElement(_materialUi.Button, {
        onClick: function onClick(event) {
          return setShowAll(true);
        }
      }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435 (", count, ')');
    }

    var content = _react2.default.createElement(_react.Fragment, null, _TableView.prototype.render.call(this), _react2.default.createElement('div', {
      style: {
        textAlign: "center"
      }
    }, _react2.default.createElement(Grid, {
      container: true,
      style: {
        display: "inline-flex",
        alignItems: "center",
        width: "auto"
      }
    }, _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(Pagination, {
      limit: limit,
      total: count,
      page: page || 1,
      style: {
        marginTop: 20
      }
    })), _react2.default.createElement(Grid, {
      item: true
    }, showAllButton))));

    return content;
  };

  return TasksView;
}(_Table.TableView), _class.propTypes = _extends({}, _Table.TableView.propTypes, {
  filters: _propTypes2.default.object,
  setFilters: _propTypes2.default.func,
  createTaskProcessor: _propTypes2.default.func.isRequired,
  updateTaskProcessor: _propTypes2.default.func.isRequired,
  createTimerProcessor: _propTypes2.default.func.isRequired,
  updateTimerProcessor: _propTypes2.default.func.isRequired,
  // createTaskReactionProcessor: PropTypes.func.isRequired,
  deleteTaskReaction: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _Table.TableView.defaultProps, {
  title: ""
}), _temp);
exports.default = (0, _materialUi.withStyles)(_Table.styles)(function (props) {
  return _react2.default.createElement(TasksView, props);
});